var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isVisible)?_c('MealPlan',_vm._b({},'MealPlan',Object.assign({}, _vm.$props, _vm.$attrs),false)):_vm._e(),(!_vm.isVisible)?_c('Loader',{staticClass:"u-ml--a u-mr--a",attrs:{"size":"large","color":"medium-gray"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }